import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { consumerViewStorageKeys } from '../constant'
import { TravelAgentService } from './travel-agent-service'

@Injectable({
    providedIn: 'root'
})
export class ConsumerViewService {
    
    consumerViewSubject = new BehaviorSubject<boolean>(false)
    consumerView = false

    constructor(
        private _travelAgentService: TravelAgentService
    ) {
        const consumerViewInit = sessionStorage.getItem(consumerViewStorageKeys.consumerView) === 'true'

        this.setConsumerLogo()

        if (consumerViewInit) {
            this.consumerView = true
            this.consumerViewSubject.next(consumerViewInit)
        }
    }

    toggleConsumerView(value: boolean) {

        if (value) {
            sessionStorage.setItem(consumerViewStorageKeys.consumerView, 'true')
        } else {
            sessionStorage.removeItem(consumerViewStorageKeys.consumerView)
        }

        this.consumerView = value
        this.consumerViewSubject.next(value)
    }

    private setConsumerLogo() {
        this._travelAgentService.travelAgentSubject.subscribe(ta => {
            if (ta?.travelAgentId) {
                this._travelAgentService.retrieveTravelAgentStaff(ta.travelAgentId).subscribe(result => {
                    if (!result.loading) {
                        const staff = result.data.travelAgentStaff
                        const companyLogo = staff?.photoUrl

                        if (companyLogo) {
                            sessionStorage.setItem(consumerViewStorageKeys.companyLogo, companyLogo)
                        }

                        // When page loads and consumer view it set to true in session storage but for
                        // some reason the conusmer logo was not present in storage trigger UI update
                        // after loading it.
                        if (this.consumerView) {
                            this.toggleConsumerView(true)
                        }
                    }

                })
            }
    })}
}
